const modalityTypes = Object.freeze({
    ServicioMixto: 261,
    SalonRegular: 495,
    Hogar: 497,
});

export default modalityTypes;